import { type ColumnWidth, type ColumnWidthTypes } from './types.js';
import { css, styled } from 'styled-components';

const getColumnStyles = (value?: ColumnWidth) => {
  if (value === undefined) {
    return css``;
  }

  if (value === 0) {
    return css`
      display: none;
    `;
  }

  return css`
    grid-column: span ${value};
    display: unset;
  `;
};

const getCenteredColumnStyles = (center?: boolean, value?: ColumnWidth) => {
  if (!value && value !== 0) {
    return css``;
  }

  if (value === 'auto' || value === 0 || !center) {
    return getColumnStyles(value);
  }

  return css`
    grid-column-start: ${12 / 2 - Math.ceil(value / 2) + 1};
    grid-column-end: ${12 / 2 + Math.ceil(value / 2) + 1};
  `;
};

const GridColumnElement = styled.div<ColumnWidthTypes>`
  ${({
    center = false,
    initial,
    lg,
    md,
    minWidth,
    mobileRowEnd,
    mobileRowStart,
    sm,
    theme,
    xl,
  }) => css`
    ${minWidth
      ? css`
          min-width: ${minWidth}px;
        `
      : undefined}

    ${getCenteredColumnStyles(center, initial)};

    grid-row-start: ${mobileRowStart};
    grid-row-end: ${mobileRowEnd};

    ${theme.mediaQueries.sm} {
      ${getCenteredColumnStyles(center, sm)};
    }

    ${theme.mediaQueries.md} {
      ${getCenteredColumnStyles(center, md)};
    }

    ${theme.mediaQueries.lg} {
      ${getCenteredColumnStyles(center, lg)};
      grid-row-start: auto;
      grid-row-end: auto;
    }

    ${theme.mediaQueries.xl} {
      ${getCenteredColumnStyles(center, xl)};
    }
  `}
`;

export const GridColumn = (
  props: ColumnWidthTypes & { readonly children?: React.ReactNode },
) => {
  const { children, ...rest } = props;

  return <GridColumnElement {...rest}>{children}</GridColumnElement>;
};
